export default __webpack_public_path__ + "media/images/features/saga/train-0d02057595276f8377e15449b856d583.png";